import React from 'react'

const CustomColumn = ({ colXLNum, colNum = 6, colMDNum, colXLLabel, colLabel = 4, colMDLabel = 4, colXLChildren, colChildren = 8, colMDChildren = 8, labelText = "", labelId = "", classes, classlabel, classChildren, isRequired, children }) => {
    return (
        <div className={`${colXLNum ? "col-xl-" + colXLNum : ""} col-lg-${colNum} col-md-${colMDNum ? colMDNum : colNum} col-sm-12 col-12 mb-2 ${classes ? classes : ""}`}>
            <div className="row">

                <div className={`${colXLLabel ? "col-xl-" + colXLLabel : ""} col-lg-${colLabel} col-md-${colMDLabel} col-sm-12 col-12 ${classlabel ? classlabel : ""}`}>
                    <label htmlFor={labelId?.split(" ")?.join("-") || ""} className={`col-form-label ${isRequired ? 'required' : ""}`}>{labelText || ""}</label>
                </div>

                <div className={`${colXLChildren ? "col-xl-" + colXLChildren : ""} col-lg-${colChildren} col-md-${colMDChildren} col-sm-12 col-12  ${classChildren ? classChildren : ""}`}>
                    {children}
                </div>
            </div>
        </div>
    )
}

export default CustomColumn
